import { UnleashClient } from 'unleash-proxy-client'

// TODO: Use shared feature-flag-service
class FeatureFlagConfig {
  constructor(appName, url = null) {
    this.appName = appName
    this.url = url
  }

  // Make service independent from Vite & Webpack configs
  getEnv(name) {
    // if (import.meta?.env) return import.meta.env['VITE_' + name]
    return process.env['VUE_APP_' + name]
  }

  get config() {
    const getEnv = this.getEnv
    const url = this.url ?? getEnv('UNLEASH_URL')
    if (!url) throw Error('Url is required for Unleash config')

    const clientKey = getEnv('UNLEASH_CLIENT_KEY')
    if (!clientKey) throw Error('ClientKey is required for Unleash config')

    let environment = getEnv('ENVIRONMENT')
    if (!environment) {
      console.warn(
        'VUE_APP_ENVIRONMENT is not defined, but required for Unleash config, setting to "development"'
      )
      environment = 'development'
    }

    return {
      url,
      refreshInterval: 15,
      clientKey,
      appName: this.appName,
      environment,
    }
  }
}

class FeatureFlagService {
  #flagsMap = new Map()
  #client
  constructor(client) {
    this.#client = client
    this.#makeUpdatable()
  }

  static async init(appName, url) {
    const config = new FeatureFlagConfig(appName, url).config
    const client = new UnleashClient(config)
    await client.start()
    const featureFlagService = new FeatureFlagService(client)
    return featureFlagService
  }

  isEnabled(flagName, onFlagValueUpdateClb = null) {
    const flag = this.#isEnabledUtils(flagName)
    if (onFlagValueUpdateClb && onFlagValueUpdateClb?.call) {
      this.#flagsMap.set(flagName, onFlagValueUpdateClb)
    }
    return flag
  }

  #isEnabledUtils(flagName) {
    return this.#client.isEnabled(flagName)
  }

  #makeUpdatable() {
    this.#client.on('update', () => {
      this.#flagsMap.forEach((func, key) => {
        if (func && func?.call) func(key, this.#isEnabledUtils(key))
      })
    })
  }
}
export default FeatureFlagService
